/* Choose Your Goob — Optimized (preload + lean helpers)
   Now supports gradients with TRUE SVG gradients (no shape change).
   Add-to-cart drawer behavior untouched (uses Shopify's product-form).
*/
(function () {
  const root = document.getElementById('choose-your-goob');
  if (!root) return;

  const icons = [...root.querySelectorAll('.cyg__icon')];
  const stageImg = root.querySelector('.cyg__stage-img');
  const panels = [...root.querySelectorAll('.cyg__panel')];

  // --- SVG gradient wiring ---
  const sid = root.dataset.sectionId;
  const svg = root.querySelector(`#cyg-ellipse-${sid}`);
  const ellipseNode = svg?.querySelector('ellipse');

  const setSvgLinear = (angleDeg, stops) => {
    const grad = svg?.querySelector(`#cyg-linear-${sid}`);
    if (!grad || !ellipseNode) return;
    grad.setAttribute('gradientTransform', `rotate(${angleDeg}, .5, .5)`);

    const [s1, s2, s3] = [
      stops?.[0] || { color: '#ff6a6a', offset: '0%' },
      stops?.[1] || { color: '#ff6a6a', offset: '100%' },
      stops?.[2] || null,
    ];

    const L1 = svg.querySelector(`#cyg-l1-${sid}`);
    const L2 = svg.querySelector(`#cyg-l2-${sid}`);
    const L3 = svg.querySelector(`#cyg-l3-${sid}`);

    if (L1) { L1.setAttribute('stop-color', s1.color || '#ff6a6a'); L1.setAttribute('offset', s1.offset || '0%'); }
    if (L2) { L2.setAttribute('stop-color', s2.color || '#ff6a6a'); L2.setAttribute('offset', s2.offset || '100%'); }
    if (L3) {
      if (s3) {
        L3.setAttribute('stop-color', s3.color || s2.color || '#ff6a6a');
        L3.setAttribute('offset', s3.offset || s2.offset || '100%');
        L3.removeAttribute('stop-opacity');
      } else {
        L3.setAttribute('stop-color', s2.color || '#ff6a6a');
        L3.setAttribute('offset', s2.offset || '100%');
        L3.setAttribute('stop-opacity', '1');
      }
    }

    ellipseNode.setAttribute('fill', `url(#cyg-linear-${sid})`);
  };

  const setSvgRadial = (stops) => {
    const [s1, s2, s3] = [
      stops?.[0] || { color: '#ff6a6a', offset: '0%' },
      stops?.[1] || { color: '#ff6a6a', offset: '100%' },
      stops?.[2] || null,
    ];

    const R1 = svg?.querySelector(`#cyg-r1-${sid}`);
    const R2 = svg?.querySelector(`#cyg-r2-${sid}`);
    const R3 = svg?.querySelector(`#cyg-r3-${sid}`);
    if (!svg || !ellipseNode || !R1 || !R2 || !R3) return;

    R1.setAttribute('stop-color', s1.color || '#ff6a6a'); R1.setAttribute('offset', s1.offset || '0%');
    R2.setAttribute('stop-color', s2.color || '#ff6a6a'); R2.setAttribute('offset', s2.offset || '100%');

    if (s3) {
      R3.setAttribute('stop-color', s3.color || s2.color || '#ff6a6a');
      R3.setAttribute('offset', s3.offset || s2.offset || '100%');
      R3.removeAttribute('stop-opacity');
    } else {
      R3.setAttribute('stop-color', s2.color || '#ff6a6a');
      R3.setAttribute('offset', s2.offset || '100%');
      R3.setAttribute('stop-opacity', '1');
    }

    ellipseNode.setAttribute('fill', `url(#cyg-radial-${sid})`);
  };

  const setSvgSolid = (color) => {
    if (!ellipseNode) return;
    ellipseNode.setAttribute('fill', color || 'currentColor');
  };

  // --- helpers ---
  const money = (cents) => {
    try {
      if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    } catch (_) {}
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
  };

  const updateStage = (src, instant = false) => {
    if (!src) return;

    // fade-out current
    stageImg.classList.remove('is-in');

    // preload
    const img = new Image();
    img.src = src;

    img.onload = () => {
      if (instant) {
        stageImg.src = src;
        stageImg.classList.add('is-in');
      } else {
        setTimeout(() => {
          stageImg.src = src;
          requestAnimationFrame(() => stageImg.classList.add('is-in'));
        }, 180);
      }
    };
  };

  // NEW: drive ellipse via SVG defs; keep --cyg-circle for UI accents
  const setCircle = (cssValue, isGradient, gradientData) => {
    const fallback = getComputedStyle(root).getPropertyValue('--default-circle').trim() || '#ff6a6a';

    if (isGradient && gradientData?.use) {
      if (gradientData.type === 'radial') {
        setSvgRadial(gradientData.stops);
      } else {
        setSvgLinear(gradientData.angle ?? 90, gradientData.stops);
      }
      // keep accents stable
      root.style.setProperty('--cyg-circle', fallback);
    } else {
      const color = (cssValue && cssValue.toString().trim()) || fallback;
      setSvgSolid(color);
      root.style.setProperty('--cyg-circle', color);
    }
  };

  const setActiveIcon = (btn) => {
    icons.forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const showPanel = (blockId) => {
    panels.forEach((p) => {
      const active = p.id === `cyg-panel-${blockId}`;
      p.toggleAttribute('hidden', !active);
      p.classList.toggle('is-active', active);
    });
  };

  // --- build product data ---
  const dataMap = {};
  panels.forEach((panel) => {
    const id = panel.id.replace('cyg-panel-', '');
    const node = document.getElementById(`cyg-data-${id}`);
    if (node) {
      try { dataMap[id] = JSON.parse(node.textContent); } catch(_) {}
    }
  });

  const resolveVariant = (data, which) => {
    const vs = data.variants || [];
    if (which === 'single' || vs.length === 1 || !data.hasTwo)
      return vs.find((v) => v.available) || vs[0];
    if (which === 'sample')
      return vs.find((v) => v.title === data.sampleMatch) || vs[0];
    if (which === 'full')
      return vs.find((v) => v.title === data.fullMatch) || vs[0];
    return vs[0];
  };

  const updatePrices = (panel, data) =>
    ['sample', 'full', 'single'].forEach((key) => {
      const el = panel.querySelector(`[data-price="${key}"]`);
      if (!el) return;
      const v = resolveVariant(data, key);
      el.textContent = ' | ' + (v ? money(v.price) : '—');
    });

  // --- init forms (skips locked panels with no form) ---
  const initPanelForms = () => {
    panels.forEach((panel) => {
      const id = panel.id.replace('cyg-panel-', '');
      const data = dataMap[id];
      if (!data) return;

      updatePrices(panel, data);

      const form = panel.querySelector('.cyg__form');
      if (!form) return; // locked / coming-soon panels have no form

      const qtyInput = form.querySelector('.cyg__qty-input');
      const decBtn = form.querySelector('[data-qty="-1"]');
      const incBtn = form.querySelector('[data-qty="1"]');
      const idInput = form.querySelector('input[name="id"]');
      const radios = [...form.querySelectorAll('input[type="radio"]')];

      // qty controls
      decBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });

      incBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });

      const updateVariant = () => {
        const which =
          radios.find((r) => r.checked)?.value ||
          (data.hasTwo ? 'sample' : 'single');
        const variant = resolveVariant(data, which);
        if (idInput && variant) idInput.value = variant.id;
        const img =
          variant?.featured_image || data.featured_image || (data.images && data.images[0]);
        updateStage(img, true);
      };

      radios.forEach((r) => r.addEventListener('change', updateVariant));
      form.addEventListener('cyg:activate', updateVariant);
      updateVariant();
    });
  };

  // --- activate product (only change: pass gradient to setCircle) ---
  const activateBlock = (blockId) => {
    const btn = icons.find((b) => b.dataset.blockId === blockId);
    if (!btn) return;
    const data = dataMap[blockId] || {};

    setActiveIcon(btn);
    showPanel(blockId);

    // Solid or gradient (SVG)
    setCircle(data.circle || data.circleColor, !!data.isGradient, data.gradient);

    const form = root.querySelector(`#cyg-panel-${blockId} .cyg__form`);
    form?.dispatchEvent(new CustomEvent('cyg:activate'));

    const which =
      form?.querySelector('input[type="radio"]:checked')?.value ||
      (data.hasTwo ? 'sample' : 'single');
    const variant = resolveVariant(data, which);
    const img =
      variant?.featured_image || data.featured_image || (data.images && data.images[0]);
    updateStage(img);
  };

  // --- preload all images after page load ---
  const preloadAllImages = () => {
    const urls = new Set();
    Object.values(dataMap).forEach((data) => {
      data.variants?.forEach((v) => v.featured_image && urls.add(v.featured_image));
      data.images?.forEach((src) => src && urls.add(src));
      if (data.featured_image) urls.add(data.featured_image);
    });
    urls.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  };

  // --- run when idle ---
  const init = () => {
    initPanelForms();
    icons.forEach((btn) => {
      btn.addEventListener('click', () => activateBlock(btn.dataset.blockId));
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateBlock(btn.dataset.blockId);
        }
      });
    });
    if (icons[0]) activateBlock(icons[0].dataset.blockId);
    window.addEventListener('load', preloadAllImages);
  };

  if ('requestIdleCallback' in window)
    requestIdleCallback(init);
  else
    window.addEventListener('DOMContentLoaded', init);
})();

// Ellipse bounce on icon / radio click
document.addEventListener('DOMContentLoaded', function () {
  const ellipse = document.querySelector('.cyg__ellipse');
  if (!ellipse) return;

  // Elements that should trigger the bounce
  const triggers = document.querySelectorAll('.cyg__icon-img, .cyg__radio-ui');

  triggers.forEach(el => {
    el.addEventListener('click', () => {
      ellipse.classList.remove('is-bouncing');
      void ellipse.offsetWidth; // force restart
      ellipse.classList.add('is-bouncing');
    });
  });
});
